import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core';
import PropTypes from 'prop-types';

const UpdateReasonForm = ({ title, children }) => {
  const [callback, setCallback] = useState(null);
  const [reason, setReason] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    callback(reason);
    setReason('');
    setCallback(null);
  };

  return (
    <>
      <Dialog open={!!callback}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            style={{ width: 450 }}
            size="small"
            label="Reason"
            minRows={1}
            value={reason}
            onChange={e => setReason(e.target.value.trimStart())}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} color="primary" disabled={!reason} variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {children({ open: submitCallback => setCallback(() => submitCallback) })}
    </>
  );
};

UpdateReasonForm.propTypes = {
  title: PropTypes.string,
  children: PropTypes.func.isRequired
};

UpdateReasonForm.defaultProps = {
  title: 'Reason for the update'
};

export default UpdateReasonForm;
